import { z } from 'zod';

import { InputPassword, type InputPasswordProps } from '@/components/controls';

export type FormInputPasswordProps = InputPasswordProps;

export const FormInputPassword = ({ ...props }: FormInputPasswordProps) => {
  return <InputPassword {...props} />;
};

FormInputPassword.displayName = 'Forms.InputPassword';

export const required = (
  message = 'La contraseña debe contener al menos 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial.',
) => {
  return z
    .string()
    .regex(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
      message,
    );
};

FormInputPassword.rules = { required };
